import { Redirect, useLocalSearchParams } from 'expo-router';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const params = useLocalSearchParams<{ assetId: string }>();

  return <Redirect withAnchor href={{ pathname: '/account/gift/checkout/[assetId]', params }} />;
}
